import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';
import URI from 'urijs';
import dialogTemplateInReview from '@bingads-webui-campaign-legacy/campaign-create-advanced/template/successDialogInReview.pug';
import dialogTemplatePendingPaymentMethod from '@bingads-webui-campaign-legacy/campaign-create-advanced/template/successDialogPendingPaymentMethod.pug';
import dialogTemplateAccountOnHold from '@bingads-webui-campaign-legacy/campaign-create-advanced/template/successDialogAccountOnHold.pug';
import dialogTemplateAccountPaused from '@bingads-webui-campaign-legacy/campaign-create-advanced/template/successDialogAccountPaused.pug';
import constants from '@bingads-webui-static-legacy/constants';
import preferencesService from '@bingads-webui-component-legacy/preference/service/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
const i18nGlobal = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');

/**
 * @this {Success}
 * @returns {void}
**/
function close() {
  this.trigger('close');
}

/**
 * @this {Success}
 * @returns {void}
**/
function save() {
  preferencesService.setAtUserLevel({
    Name: 'WebApp.CampaignUI.successDialog',
    Data: { doNotShowAgain: this.viewModel.doNotShowAgain() },
  });
}

export class Success extends Backbone.View {
  initialize({
    aid = null,
    cid = null,
    uid = null,
    isPendingPaymentMethod = false,
    isAccountOnHold = false,
    accountPausedReason = constants.enums.accountInactiveReason.notSet,
  } = {}) {
    this.isPendingPaymentMethod = isPendingPaymentMethod;
    this.isAccountOnHold = isAccountOnHold;
    this.accountPausedReason = accountPausedReason;
    this.aid = aid;
    this.cid = cid;
    this.uid = uid;

    this.viewModel = {
      doNotShowAgain: ko.observable(false),
    };
  }

  get events() {
    return {
      'click .got-it': close,
      'click .dont-show': save,
    };
  }

  render() {
    if (this.accountPausedReason) {
      let reason;
      let action;
      let link;

      switch (this.accountPausedReason) {
      case constants.enums.accountInactiveReason.pausedDueToSystemIssue:
        reason = 'SystemIssue';
        action = 'ContactSupport';
        link = new URI('http://go.microsoft.com/fwlink/?LinkId=258669').toString();
        break;
      case constants.enums.accountInactiveReason.pausedZeroBalance:
        reason = 'ZeroBalance';
        action = 'AddFunds';
        link = new URI('/cc/Payment/Prepay').setQuery({
          aid: this.aid,
          cid: this.cid,
          uid: this.uid,
        }).toString();
        break;
      case constants.enums.accountInactiveReason.pausedNoValidiO:
        reason = 'NoValidIO';
        action = 'CreateInsertionOrder';
        link = new URI('/cc/InsertionOrder').setQuery({
          aid: this.aid,
          cid: this.cid,
          uid: this.uid,
        }).toString();
        break;
      default:
        break;
      }
      this.$el.html(dialogTemplateAccountPaused({
        _,
        i18n,
        i18nGlobal,
        reason,
        action,
        link,
      }));
    } else if (this.isPendingPaymentMethod) {
      const hrefAddPaymentMethod = new URI('/cc/PaymentMethods').setQuery({
        aid: this.aid,
        cid: this.cid,
        uid: this.uid,
        showTaxForm: false,
      }).toString();

      this.$el.html(dialogTemplatePendingPaymentMethod({
        _,
        i18n,
        i18nGlobal,
        hrefAddPaymentMethod,
      }));
    } else if (this.isAccountOnHold) {
      const hrefFixIt = new URI('/cc/CreditHold/Dashboard').setQuery({
        aid: this.aid,
        cid: this.cid,
        uid: this.uid,
      }).toString();

      this.$el.html(dialogTemplateAccountOnHold({
        _,
        i18n,
        i18nGlobal,
        hrefFixIt,
      }));
    } else {
      this.$el.html(dialogTemplateInReview({
        _,
        i18n,
        i18nGlobal,
      }));
    }
    ko.applyBindings(this.viewModel, this.el);

    return this;
  }
}
